var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#00C09E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 25H29V23H27V25ZM28 36C23.59 36 20 32.41 20 28C20 23.59 23.59 20 28 20C32.41 20 36 23.59 36 28C36 32.41 32.41 36 28 36ZM28 18C26.6868 18 25.3864 18.2587 24.1732 18.7612C22.9599 19.2638 21.8575 20.0003 20.9289 20.9289C19.0536 22.8043 18 25.3478 18 28C18 30.6522 19.0536 33.1957 20.9289 35.0711C21.8575 35.9997 22.9599 36.7362 24.1732 37.2388C25.3864 37.7413 26.6868 38 28 38C30.6522 38 33.1957 36.9464 35.0711 35.0711C36.9464 33.1957 38 30.6522 38 28C38 26.6868 37.7413 25.3864 37.2388 24.1732C36.7362 22.9599 35.9997 21.8575 35.0711 20.9289C34.1425 20.0003 33.0401 19.2638 31.8268 18.7612C30.6136 18.2587 29.3132 18 28 18ZM27 33H29V27H27V33Z",
    fill: "#00C09E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.25f0d740.svg";
export { ForwardRef as ReactComponent };